import { createContext } from 'react'

export const ChatControllerContext = createContext(null)
